module.exports = __webpack_public_path__ + "static/scale-model-of-hermann-park-lake-plaza-in-houston-texas-7d52058ffe3b517fefb2f350852de283.png";